<!--
 * @Author: Junjie
 * @Date: 2022-11-18 13:51:39
 * @LastEditTime: 2022-11-20 15:58:26
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/jeecg/category/CommonCategoryList.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('分类字典')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :expandedRowKeys="expandedRowKeys"
        :loading="loading"
        :pagination="ipagination"
        @change="handleTableChange"
        @expand="handleExpand"
        ref="table"
        rowKey="id"
        size="middle"
        v-bind="tableProps"
      >
        <span slot="enable" slot-scope="text, record">
          <a-switch
            :checked="!!(record.enable - 0)"
            @change="handleEnable(record, !(record.enable-0) ? 1 : 0)"
            checked-children="启用"
            un-checked-children="禁用"
          />
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(Object.assign(record, {enable: !!(record.enable - 0)})  )">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm @confirm="() => handleDelete(record)" title="确定删除吗?">
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleAddSub(record)">添加下级</a>
        </span>
      </a-table>
    </div>

    <common-category-modal @ok="modalFormOk" ref="modalForm"></common-category-modal>
  </a-card>
</template>

<script>

  import { getAction, putAction, deleteAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CommonCategoryModal from './modules/CommonCategoryModal'

  export default {
    name: "SysCategoryList",
    mixins: [JeecgListMixin],
    components: {
      CommonCategoryModal
    },
    data () {
      return {
        description: '公共编码管理页面',
        isorter: {
          column: 'sortNo',
          order: 'asc'
        },
        // 表头
        columns: [
          {
            title: '名称',
            align: "left",
            dataIndex: 'name',
            width: '22%',
            sorter: true,
          },
          {
            title: '编码',
            align: "left",
            dataIndex: 'code',
            sorter: true,
          },
          {
            title: '自定义属性1',
            align: "left",
            dataIndex: 'cusProp1',
            ellipsis: true,
            sorter: true,
          },
          {
            title: '自定义属性2',
            align: "left",
            dataIndex: 'cusProp2',
            ellipsis: true,
            sorter: true,
          },
          {
            title: '自定义属性3',
            align: "left",
            dataIndex: 'cusProp3',
            sorter: true,
          },
          {
            title: '是否启用',
            align: "center",
            dataIndex: 'enable',
            scopedSlots: { customRender: 'enable' },
            width: 100,
            sorter: true,
          },
          {
            title: '排序',
            align: "center",
            dataIndex: 'sortNo',
            width: 80,
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            scopedSlots: { customRender: 'action' },
            width: 180,
          }
        ],
        url: {
          list: "/custom/category/rootList",
          childList: "/custom/category/childList",
          getChildListBatch: "/custom/category/getChildListBatch",
          delete: "/custom/category/delete",
          deleteBatch: "/custom/category/deleteBatch",
          edit: "/custom/category/edit",
          exportXlsUrl: "/custom/category/exportXls",
          importExcelUrl: "custom/category/importExcel",
        },
        expandedRowKeys: [],
        hasChildrenField: "hasChild",
        pidField: "pid",
        dictOptions: {
        },
        subExpandedKeys: [],
      }
    },
    computed: {
      importExcelUrl () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      tableProps () {
        let _this = this
        return {
          // 列表项是否可选择
          rowSelection: {
            selectedRowKeys: _this.selectedRowKeys,
            onChange: (selectedRowKeys) => _this.selectedRowKeys = selectedRowKeys
          }
        }
      }
    },
    methods: {
      handleEnable (record, enable) {
        let params = Object.assign({}, record, { enable });
        delete params.children;
        putAction(this.url.edit, params).then(res => {
          if (res.success) {
            this.loadData()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      loadData (arg) {
        if (arg == 1) {
          this.ipagination.current = 1
        }
        this.loading = true
        let params = this.getQueryParams()
        return new Promise((resolve) => {
          getAction(this.url.list, params).then(res => {
            if (res.success) {
              let result = res.result
              if (Number(result.total) > 0) {
                this.ipagination.total = Number(result.total)
                this.dataSource = this.getDataByResult(res.result.records)
                //update--begin--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
                return this.loadDataByExpandedRows(this.dataSource)
                //update--end--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
              } else {
                this.ipagination.total = 0
                this.dataSource = []
              }
            } else {
              this.$message.warning(res.message)
            }
          }).finally(() => {
            this.loading = false
          })
        })
      },
      getDataByResult (result) {
        if (result && result.length > 0) {
          return result.map(item => {
            //判断是否标记了带有子节点
            if (item[this.hasChildrenField] == '1') {
              let loadChild = { id: item.id + '_loadChild', name: 'loading...', isLoading: true }
              item.children = [loadChild]
            }
            return item
          })
        }
      },
      handleExpand (expanded, record) {
        // 判断是否是展开状态
        if (expanded) {
          this.expandedRowKeys.push(record.id)
          if (record.children.length > 0 && record.children[0].isLoading === true) {
            let params = this.getQueryParams();//查询条件
            params[this.pidField] = record.id
            getAction(this.url.childList, params).then((res) => {
              if (res.success) {
                if (res.result && res.result.length > 0) {
                  record.children = this.getDataByResult(res.result)
                  this.dataSource = [...this.dataSource]
                } else {
                  record.children = ''
                  record.hasChildrenField = '0'
                }
              } else {
                this.$message.warning(res.message)
              }
            })
          }
        } else {
          let keyIndex = this.expandedRowKeys.indexOf(record.id)
          if (keyIndex >= 0) {
            this.expandedRowKeys.splice(keyIndex, 1);
          }
        }
      },
      initDictConfig () {
      },
      modalFormOk (formData, arr) {
        if (!formData.id) {
          this.addOk(formData, arr)
        } else {
          this.editOk(formData, this.dataSource)
          this.dataSource = [...this.dataSource]
        }
      },
      editOk (formData, arr) {
        if (arr && arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == formData.id) {
              arr[i] = formData
              break
            } else {
              this.editOk(formData, arr[i].children)
            }
          }
        }
      },
      async addOk (formData, arr) {
        if (!formData[this.pidField]) {
          this.loadData()
        } else {
          this.expandedRowKeys = []
          for (let i of arr) {
            await this.expandTreeNode(i)
          }
        }
      },
      expandTreeNode (nodeId) {
        return new Promise((resolve, reject) => {
          this.getFormDataById(nodeId, this.dataSource)
          let row = this.parentFormData
          this.expandedRowKeys.push(nodeId)
          let params = this.getQueryParams();//查询条件
          params[this.pidField] = nodeId
          getAction(this.url.childList, params).then((res) => {
            if (res.success) {
              if (res.result && res.result.length > 0) {
                row.children = this.getDataByResult(res.result)
                this.dataSource = [...this.dataSource]
                resolve()
              } else {
                row.children = ''
                row.hasChildrenField = '0'
                reject()
              }
            } else {
              reject()
            }
          })
        })
      },
      getFormDataById (id, arr) {
        if (arr && arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == id) {
              this.parentFormData = arr[i]
            } else {
              this.getFormDataById(id, arr[i].children)
            }
          }
        }
      },
      handleAddSub (record) {
        this.subExpandedKeys = [];
        this.getExpandKeysByPid(record.id, this.dataSource, this.dataSource)
        this.$refs.modalForm.subExpandedKeys = this.subExpandedKeys;
        this.$refs.modalForm.title = "添加子分类";
        this.$refs.modalForm.edit({ 'pid': record.id });
        this.$refs.modalForm.disableSubmit = false;
      },
      handleDelete: function (record) {
        let that = this;
        deleteAction(that.url.delete, { id: record.id }).then((res) => {
          if (res.success) {
            //update--begin--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
            that.loadData();
            //update--end--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      // 添加子分类时获取所有父级id
      getExpandKeysByPid (pid, arr, all) {
        if (pid && arr && arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == pid) {
              this.subExpandedKeys.push(arr[i].id)
              this.getExpandKeysByPid(arr[i]['pid'], all, all)
            } else {
              this.getExpandKeysByPid(pid, arr[i].children, all)
            }
          }
        }
      },
      // 根据已展开的行查询数据（用于保存后刷新时异步加载子级的数据）
      loadDataByExpandedRows (dataList) {
        if (this.expandedRowKeys.length > 0) {
          const parms = Object.assign({ parentIds: this.expandedRowKeys.join(',') }, this.isorter);
          return getAction(this.url.getChildListBatch, parms).then(res => {
            if (res.success && res.result.records.length > 0) {
              //已展开的数据批量子节点
              let records = res.result.records
              const listMap = new Map();
              for (let item of records) {
                let pid = item[this.pidField];
                if (this.expandedRowKeys.join(',').includes(pid)) {
                  let mapList = listMap.get(pid);
                  if (mapList == null) {
                    mapList = [];
                  }
                  mapList.push(item);
                  listMap.set(pid, mapList);
                }
              }
              let childrenMap = listMap;
              let fn = (list) => {
                if (list) {
                  list.forEach(data => {
                    if (this.expandedRowKeys.includes(data.id)) {
                      data.children = this.getDataByResult(childrenMap.get(data.id))
                      fn(data.children)
                    }
                  })
                }
              }
              fn(dataList)
            }
          })
        } else {
          return Promise.resolve()
        }
      },


    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>